import React from 'react';
import { Box, Typography } from '@mui/material';
import logo from '../../assets/images/logo.svg';

const sx = {
  root: {
    width: '100%',
    p: '24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    pb: '100px',
  },
  text: {
    fontSize: '22px',
    fontFamily: 'boucherie-block',
  },
  img: {
    cursor: 'pointer',
  }
};

const Footer = () => {
  const openGalaxis = () => {
    window.open(`https://galaxis.xyz/#/`, '_blank');
  }
  return (
    <Box sx={sx.root}>
      <Typography sx={sx.text}>POWERED BY:</Typography>
      <Box sx={sx.img} src={logo} component="img" onClick={() => { openGalaxis() }}></Box>
    </Box>)
};

export default Footer;
